import { render, staticRenderFns } from "./products-filter-name.vue?vue&type=template&id=1e10294f&"
import script from "./products-filter-name.vue?vue&type=script&lang=js&"
export * from "./products-filter-name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports